import { Breadcrumb, Select, Input, Timeline } from "antd";
import { t } from "i18next";
import { ActiveDotIcon, InactiveDotIcon, BackIcon } from '../../../../asset';
import { CloseIcon } from '../../../../asset';
import React, { useState } from 'react';
import style from './palletPage.module.css';
import ConfirmationModal from "../../../../component/modal/ConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useLocation, useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import TextArea from "antd/es/input/TextArea";
import { usePallet } from "./PalletPage.hooks";
import { useEffect } from "react";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";

export default function PalletDetail() {
    const [userManagementOpen, setUserManagementOpen] = useState(false);

    const { state } = useLocation();

    const {
        doGetDetailPallet,
        detailPallet,
        convertTimestamp,
        convertToTime,
        toEditPallet,
        toListPallet,
        deleteConfirmationModalOpen,
        deleteConfirmation,
        successModalOpen,
        setSuccessModalOpen,
        selectedId,
        selectedPalletName,
        deleteData,
        setDeleteConfirmationModalOpen,
        doDeletePallet,
        doGetManagementHistoryList,
        managementHistoryList
    } = usePallet()

    useEffect(() => {
        doGetDetailPallet(state.id)
        doGetManagementHistoryList(state.id)
    }, [])

    const navigate = useNavigate()

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <DeleteConfirmationModal
                isOpen={deleteConfirmationModalOpen}
                onOk={() => setDeleteConfirmationModalOpen(false)}
                onCancel={() => doDeletePallet()}
                closable={false}
                width={440}
                className={style.modalContainer}
                okText="Cancel"
                cancelText="Yes, Delete"
                title="Delete Data?"
                description={<p>Are you Sure want to delete <strong>{selectedId} - {selectedPalletName}</strong></p>}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={() => navigate(ROUTES.PALLET.LIST)}
                closable={false}
                width={280}
                className={style.deleteModal}
                okText="Ok"
                title="Success"
                description="Your data has been deleted"
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Pallet`}
                menuLevel4={`Detail ${detailPallet?.pallet_id} - ${detailPallet?.pallet_name}`}
            />

            <div className="flex items-center justify-between gap-[22px]">
                <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => toListPallet()}>
                    <img src={BackIcon} alt="back-icon" />
                    <h1 className='font-sans-bold text-2xl' id='title'>{`${t("PALLET_DETAIL:TITLE")} ${detailPallet?.pallet_id} - ${detailPallet?.pallet_name}`}</h1>
                </div>

                <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
                    <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detailPallet?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailPallet?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{detailPallet?.updated_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailPallet?.updated_at, true)}</strong></p>
                </div>
            </div>

            <div className="border-[#DDDDDD] flex flex-col gap-[24px] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px]">
                <div>
                    <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("PALLET_DETAIL:PALLET_INFORMATION")}</h3>

                    <div className="flex gap-[16px]">
                        <div className="flex flex-col w-[350px]">
                            <label className="text-[#818181] font-[400] text-sm">{t("PALLET_DETAIL:PALLET_ID_FIELD")}</label>
                            <p className="text-[#424242] font-[500] text-[16px]">{detailPallet?.pallet_id}</p>
                        </div>
                        <div className="flex flex-col w-[350px]">
                            <label className="text-[#818181] font-[400] text-sm">{t("PALLET_DETAIL:PALLET_NAME_FIELD")}</label>
                            <p className="text-[#424242] font-[500] text-[16px]">{detailPallet?.pallet_name}</p>
                        </div>
                        <div className="flex flex-col w-[350px]">
                            <label className="text-[#818181] font-[400] text-sm">{t("PALLET_DETAIL:DESCRIPTION_PALLET_FIELD")}</label>
                            <p className="text-[#424242] font-[500] text-[16px] max-[350px]">{detailPallet?.description}</p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-[16px]">
                    <h3 className="font-roboto font-medium text-lg">{t("PALLET_DETAIL:PALLET_SPECIFICATION")}</h3>

                    <div className="flex gap-[16px]">
                        <div className="flex flex-col w-[350px]">
                            <label className="text-[#818181] font-[400] text-sm">{t("PALLET_DETAIL:WEIGHT_FIELD")}</label>
                            <p className="text-[#424242] font-[500] text-[16px]">{`${detailPallet?.weight} Kg`}</p>
                        </div>
                        <div className="flex flex-col w-[350px]">
                            <label className="text-[#818181] font-[400] text-sm">{t("PALLET_DETAIL:LENGHT_FIELD")}</label>
                            <p className="text-[#424242] font-[500] text-[16px]">{`${detailPallet?.length} M`}</p>
                        </div>
                        <div className="flex flex-col w-[350px]">
                            <label className="text-[#818181] font-[400] text-sm">{t("PALLET_DETAIL:WIDTH_FIELD")}</label>
                            <p className="text-[#424242] font-[500] text-[16px]">{`${detailPallet?.width} M`}</p>
                        </div>
                    </div>
                    <div className="flex flex-col w-[350px]">
                        <label className="text-[#818181] font-[400] text-sm">{t("PALLET_DETAIL:HEIGHT_FIELD")}</label>
                        <p className="text-[#424242] font-[500] text-[16px]">{`${detailPallet?.height} M`}</p>
                    </div>
                </div>

            </div>
            <div className="flex flex-row-reverse justify-start gap-[16px]">
                <button className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" onClick={detailPallet !== null ? () => toEditPallet(detailPallet) : null}>
                    {t("PALLET_DETAIL:EDIT_BUTTON")}
                </button>
                <button className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]" onClick={() => deleteData(detailPallet?.pallet_id, detailPallet?.updated_at, detailPallet?.pallet_name)}>
                    {t("PALLET_DETAIL:DELETE_BUTTON")}
                </button>
            </div>


            <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
                <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
                    <img src={CloseIcon} alt="" />
                </button>

                <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
                <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detailPallet?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detailPallet?.created_at)}</strong></p>


                <div className={style.timelineContainer}>
                    <Timeline>
                        {
                            managementHistoryList.map((item, index) => {
                                if (index === 0) {
                                    return (
                                        <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                                            <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                                                <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                                                <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                                                <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                                            </div>
                                        </Timeline.Item>
                                    )
                                } else {
                                    return (
                                        <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                                            <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                                                <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                                                <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                                                <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                                            </div>
                                        </Timeline.Item>
                                    )
                                }
                            })
                        }
                    </Timeline>
                </div>
            </aside>
        </div>
    )
}
